// Where to send a user right after authentication. This is an admin-only console
// now (the liveness end-users never log in — they use the hosted /v/{token} page),
// so everyone lands on the administration area.
export function landingPath(user) {
  const caps = user?.capabilities || {};
  if (caps.manage_users) return "/liveness/admin/accounts";
  return "/liveness/admin/client-apps";
}
